import {
  ContactPopup,
  Loader,
  Sidebar,
  Toast,
  clearLocalStorageKeys,
  deleteOfflineAccessKeyFromCache,
  deserify,
  getLocalStorage,
  pxToRem,
  pxTovW,
  theme,
  useCommonServiceClientContext,
} from '@geneo2-web/shared-ui';
import { Box, useMediaQuery } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import {
  Outlet,
  ScrollRestoration,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import Header from '../../components/Header';
import { resetAnalyticsState } from '../../pages/Analytics/reducer/analytics.slice';
import { interactionEvent } from '../../pages/Auth/auth.events';
import {
  resetAuthState,
  setContactPopupOpen,
  setUserInfo,
} from '../../pages/Auth/reducer/auth.slice';
import {
  resetHomeDashboardState,
  toggleToastOpen,
  toggleToastOpen2,
} from '../../pages/Home/reducer/homeDashboard.slice';

import { resetManageHWState } from '../../pages/ManageHomework/reducer/manageHomework.slice';
import { resetConnectedClassState } from '../../pages/Teach/reducer/connectedClass.slice';
import { resetTeachState } from '../../pages/Teach/reducer/teach.slice';
import { useAppDispatch, useAppSelector } from '../../reduxStore/reduxHooks';
import { useSideBarOptions } from '../../utils/sidebarOptions';
import { useDownloadContext } from '../Context/DownloadContextProviderV2';
import { resetAssessmentFlowState } from '../../pages/Assessment/reducer/assessmentFlow.slice';

export default function AppLayout() {
  // console.log('main app mounted');
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const { isOffline } = useDownloadContext();

  const { user_info, contact_popup_open, isLoggingOut } = deserify(
    useAppSelector((state) => state.auth)
  );
  const { toastInfo, toastInfoV2 } = deserify(
    useAppSelector((state) => state.homeDashboard)
  );
  const [sidebarDisplay, setSidebarDisplay] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);
  const dispatch = useAppDispatch();
  const teacher_profile_id = deserify(getLocalStorage('userId'));
  const options = useSideBarOptions();
  const { UMSLoginAPIServiceV1ClientWithStatusCodeHandler } =
    useCommonServiceClientContext();

  useEffect(() => {
    if (!user_info && teacher_profile_id) {
      getTeacherProfile(teacher_profile_id);
    }
  }, [user_info]);

  const getTeacherProfile = async (teacherId: string) => {
    try {
      setLoading(true);
      const response =
        await UMSLoginAPIServiceV1ClientWithStatusCodeHandler.fetchTeacherProfile(
          {
            teacherProfileId: BigInt(teacherId),
          }
        );
      if (response.data) {
        dispatch(setUserInfo(response.data));
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
      setError(true);
      dispatch(resetAuthState());
      dispatch(resetHomeDashboardState());
      dispatch(resetAssessmentFlowState());
      dispatch(resetManageHWState());
      dispatch(resetTeachState());
      dispatch(resetConnectedClassState());
      dispatch(resetAnalyticsState());
      // navigate('/login');
      // localStorage.clear();
      clearLocalStorageKeys();
      deleteOfflineAccessKeyFromCache();
    }
  };
  const closeToastHandler = () => {
    dispatch(toggleToastOpen(false));
  };
  const toast1Ref = useRef<HTMLDivElement>(null);
  const [toast2Offset, setToast2Offset] = useState(0);
  const closeToastHandler2 = () => {
    dispatch(toggleToastOpen2(false));
  };

  useEffect(() => {
    if (toastInfo?.open) {
      if (toast1Ref.current) {
        const rect = toast1Ref.current?.getBoundingClientRect();
        // console.log(rect);
        setToast2Offset(rect?.bottom ? rect.bottom + 10 : 0);
      }
    } else {
      setToast2Offset(0);
    }
  }, [toastInfo?.open]);

  return (
    <Box>
      {isLoggingOut && <Loader />}
      <Toast
        ref={toast1Ref}
        variant={toastInfo?.variant}
        open={toastInfo?.open}
        label={toastInfo?.label}
        onClose={closeToastHandler}
      />
      <Toast
        variant={toastInfoV2?.variant}
        open={toastInfoV2?.open}
        label={toastInfoV2?.label}
        onClose={closeToastHandler2}
        offset={toast2Offset}
      />
      {isMobile && (
        <Sidebar
          open={sidebarDisplay}
          handleClose={() => setSidebarDisplay(false)}
          options={options}
        />
      )}
      <Header
        sidebarDisplay={sidebarDisplay}
        setSidebarDisplay={setSidebarDisplay}
      />
      <ContactPopup
        open={contact_popup_open}
        setOpen={async (val: boolean) => {
          dispatch(setContactPopupOpen(val));
          await interactionEvent({
            context: 'contact',
            name: 'contact_us_popup_close',
            pathSegments: pathSegments,
            isOffline: isOffline,
          });
        }}
        schoolId={user_info?.schoolDetails[0]?.schoolId}
      />
      <Box
        sx={{
          paddingTop: { xs: pxToRem(60), md: pxTovW(100) },
          // overflowX: 'hidden',
        }}
      >
        <Outlet />
        <ScrollRestoration />
      </Box>
    </Box>
  );
}
